import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  SUB_PARTNERS_SORT_KEYS
} from '@/features/shared/models'

export const SubPartnersListSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(SUB_PARTNERS_SORT_KEYS),
  name: optional(string()), // 運送会社名
  dcId: optional(number()),
  enable: optional(boolean())
})

export type SubPartnersListSearch = InferOutput<
  typeof SubPartnersListSearchSchema
>
